module.exports = __webpack_public_path__ + "img/img_3.146aa024.png";